export default __webpack_public_path__ + "static/media/k8.49bd9e68.jpg";